module.exports = __webpack_public_path__ + "static/media/socks.1453c8c5.svg";